import { render, staticRenderFns } from "./new-posts.vue?vue&type=template&id=00dec18d&scoped=true&"
import script from "./new-posts.vue?vue&type=script&lang=js&"
export * from "./new-posts.vue?vue&type=script&lang=js&"
import style0 from "./new-posts.vue?vue&type=style&index=0&id=00dec18d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00dec18d",
  null
  
)

export default component.exports